export function commaSeperated(n) {
    const a = String(n).replace(',', '');
    return Number(Number(a).toFixed(2)) != 0 ? Number(a).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}) : 0
}